module.exports = __webpack_public_path__ + "media/bootstrap-icons/menu-app-fill-0a30db4e.svg";